import { render, staticRenderFns } from "./RteParser.vue?vue&type=template&id=235870ce&"
import script from "./RteParser.vue?vue&type=script&lang=js&"
export * from "./RteParser.vue?vue&type=script&lang=js&"
import style0 from "./RteParser.vue?vue&type=style&index=0&id=235870ce&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports